var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_313_20669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 11.3334L16.0013 11.3401M16.0013 16.0001L16.0013 16.0067M16.0013 20.6667L16.0013 20.6734M16.0013 12.0001C15.6331 12.0001 15.3346 11.7016 15.3346 11.3334C15.3346 10.9652 15.6331 10.6667 16.0013 10.6667C16.3695 10.6667 16.668 10.9652 16.668 11.3334C16.668 11.7016 16.3695 12.0001 16.0013 12.0001ZM16.0013 16.6667C15.6331 16.6667 15.3346 16.3683 15.3346 16.0001C15.3346 15.6319 15.6331 15.3334 16.0013 15.3334C16.3695 15.3334 16.668 15.6319 16.668 16.0001C16.668 16.3683 16.3695 16.6667 16.0013 16.6667ZM16.0013 21.3334C15.6331 21.3334 15.3346 21.0349 15.3346 20.6667C15.3346 20.2986 15.6331 20.0001 16.0013 20.0001C16.3695 20.0001 16.668 20.2986 16.668 20.6667C16.668 21.0349 16.3695 21.3334 16.0013 21.3334Z",
    stroke: "#F6F6F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 30.5,
    height: 30.5,
    rx: 7.25,
    stroke: "#656667",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_313_20669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFrame);
export default __webpack_public_path__ + "static/media/MenuFrame.5bb8cb2e5c36c1ea1967f10e46dad49c.svg";
export { ForwardRef as ReactComponent };